'use client';
import React, {useEffect,useState,useCallback,memo,useRef} from "react";
import { toPng } from "html-to-image";
import { debounce } from "lodash";
import { Services } from "../../network/Services";
import Loader from "../Loader";
import Toaster from "../Toaster";
import config from "../../config.json";
import { isNotValidNullUndefile } from "../../control/Constant";

/* =========================
   FEEDBACK COMPONENT
========================= */
export default function Feedback() {
  const [showModal, setShowModal] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState("2");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [feedbackPriority, setFeedbackPriority] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [useLoader, setUseLoader] = useState(false);
  const [toast, setToast] = useState(null);

  /* =========================
     SESSION DATA
  ========================= */
  // const getObjFromStorage = (key) => JSON.parse(sessionStorage.getItem(key));
const getObjFromStorage = (key) => {
  const value = sessionStorage.getItem(key);
  if (!isNotValidNullUndefile(value)) {
    return null;
  }
  if (value.startsWith("{") || value.startsWith("[")) {
    return JSON.parse(value);
  }
  return value;
};


  const userLoggedInDetail = getObjFromStorage("userLoggedInDetail");
  const feedBackCreatedBy = sessionStorage.getItem("feedBackCreatedBy");
  const feedBackUserID = sessionStorage.getItem("feedBackUserID");
  const feedBackuserLoggedInDetail = getObjFromStorage("feedBackuserLoggedInDetail") || userLoggedInDetail
  const stateObj = getObjFromStorage("stateObj");
  const subtenantId = getObjFromStorage("subtenantId");
  const currentTime = new Date().toLocaleString();

  /* =========================
     DISABLE BACKGROUND SCROLL
  ========================= */
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    if (showModal) {
      body.classList.add("overflow-hidden");
      html.classList.add("overflow-hidden");
    } else {
      body.classList.remove("overflow-hidden");
      html.classList.remove("overflow-hidden");
    }

    return () => {
      body.classList.remove("overflow-hidden");
      html.classList.remove("overflow-hidden");
    };
  }, [showModal]);

  /* =========================
     FETCH PRIORITY
  ========================= */
  useEffect(() => {
    getFeedbackPriority();
  }, []);

  const getFeedbackPriority = async () => {
    try {
      setUseLoader(true);
      const res = await Services.getFeedbackPriority();
      setFeedbackPriority(res?.data?.data || []);
    } catch {
    } finally {
      setUseLoader(false);
    }
  };

  /* =========================
     SCREENSHOT + MODAL
  ========================= */
const convertImagesToBase64 = async () => {
  const images = Array.from(document.querySelectorAll("img"));

  for (const img of images) {
    // Clear any stale marker from a previous capture attempt
    img.removeAttribute("data-skip-capture");

    try {
      // Skip already converted / inline images
      if (!img.src || img.src.startsWith("data:")) continue;

      const response = await fetch(img.src, { mode: "cors" });
      const blob = await response.blob();

      await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          img.src = reader.result;
          resolve();
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      // Could not inline this image (e.g. cross-origin without CORS headers).
      // Mark it so the screenshot step skips it; otherwise it would taint the
      // canvas and make the whole toPng() call throw a SecurityError.
      img.setAttribute("data-skip-capture", "true");
      console.warn("Image base64 conversion failed, skipping in capture:", img.src);
    }
  }
};

const handleFeedbackShow = async () => {
  // OPEN FLOW
  if (!showModal) {
    try {
      // setUseLoader(true);

      // 1️⃣ Hide <noscript> (important)
      const noscripts = document.querySelectorAll("noscript");
      noscripts.forEach(n => (n.style.display = "none"));

      // 2️⃣ Convert external images to base64 (KEY FIX)
      await convertImagesToBase64();

      // 3️⃣ Small delay to ensure DOM repaint
      await new Promise(res => setTimeout(res, 50));

      // 4️⃣ Take screenshot.
      // Skip any element we flagged as un-inlinable (cross-origin images without
      // CORS headers). Including them would taint the canvas and make toPng throw.
      const dataUrl = await toPng(document.body, {
        cacheBust: true,
        pixelRatio: 2,
        filter: (node) =>
          !(node instanceof HTMLElement &&
            node.getAttribute("data-skip-capture") === "true"),
      });

      setImageSrc(dataUrl);


      // 5️⃣ Restore <noscript>
      noscripts.forEach(n => (n.style.display = ""));

      // 6️⃣ Open modal
      setShowModal(true);

    } catch (error) {
      console.error("Screenshot failed:", error);
      setToast({ message: "Screenshot failed", type: "error" });
    } finally {
      setUseLoader(false);
    }
  }

  // CLOSE FLOW
  else {
    resetState();
    setImageSrc(null);
    setShowModal(false);
  }
};


// const handleFeedbackShow = async () => {
//     setUseLoader(true);
//     if(showModal == false){
//        try {

//     // HIDE <noscript> BEFORE CAPTURE
//     const noscripts = document.querySelectorAll("noscript");
//     noscripts.forEach(n => (n.style.display = "none"));

//     const dataUrl = await toPng(document.body, {
//       cacheBust: true,
//       pixelRatio: 2,
//     });

//     setImageSrc(dataUrl);

//     // RESTORE <noscript>
//     noscripts.forEach(n => (n.style.display = ""));

//     setShowModal(true);
//   } catch (e) {
//     setToast({ message: "Screenshot failed", type: "error" });
//   } finally {
//     setUseLoader(false);
//   }
//     }else{
//         resetState();
//         setUseLoader(false)
//     }
//     setShowModal(!showModal);


// };




const resetState = () => {
    setSelectedPriority("2");
    setDescriptionValue("");
};

  /* =========================
     VALIDATION
  ========================= */
const isAnyErr = (res) => {
    if (res == "err") {
      setToast({
        message: "Something went wrong, please try again later.",
        type: "error"
      });
      return true;
    }
    return false;
};

  /* =========================
     SUBMIT FEEDBACK
  ========================= */
    const handleFeedbackSubmit = async () => {
        if (descriptionValue == "") {
            setToast({ message: 'Feedback query cannot be blank.', type: "error" });
            return;
        }
        setUseLoader(true);
        // 1) Upload Image
        const imageUploadResObj = await handleImageSubmit();
        if (isAnyErr(imageUploadResObj)) {
            setUseLoader(false);
            return;
        }
        // 2) Submit Feedback
        const feedbackPostRes = await postFeedback(imageUploadResObj);
        if (isAnyErr(feedbackPostRes)) {
            setUseLoader(false);
            return;
        }

        // 3) Send Email with Attachment
        const postEmailRes = await sendFeedBackEmail(imageUploadResObj?.blob, subtenantId, feedbackPostRes);
        if (isAnyErr(postEmailRes)) {
            setUseLoader(false);
            return;
        }

        // 4) Acknowledgement Email
        const acknowledgeMailRes = await functionForAcknowledgementMail(feedbackPostRes);
        if (isAnyErr(acknowledgeMailRes)) {
            setUseLoader(false);
            return;
        }

        // 5) Everything Successful

        setToast({ message: "Feedback submitted successfully", type: "success" });

        setUseLoader(false);
        handleFeedbackShow();
    };
    const handleImageSubmit = () => {
        return new Promise(async (resolve) => {
            setUseLoader(true);
            const fileTypeId = 3;
            const fileCategoryId = 7;
            const fileStatusId = 2;
            const blob = await fetch(imageSrc).then(res => res.blob());
            const file = new File([blob], "FEEDBACK.jpg", { type: "image/png" });
            await Services.postFileUpload(file,stateObj?.userId || feedBackUserID,stateObj?.userId || feedBackUserID,fileTypeId,fileCategoryId,fileStatusId).then((response) => {
                    const imageUrl = response?.data?.data?.fileURL;
                    const fileId = response?.data?.data?.fileId;
                    resolve({ imageUrl, fileId, blob });
                }).catch(() => {
                    resolve("err");
                    setUseLoader(false)
                }) .finally(() => {
                    // setUseLoader(false);
                });

        });
    };
    const postFeedback = async (imageUploadResObj) => {
        const { imageUrl, fileId } = imageUploadResObj;

        const payload = {
            userId: stateObj?.userId || feedBackUserID,
            feedbackQuery: descriptionValue,
            feedbackType: "string",
            applicationURL: window.location.href,
            imageURL: imageUrl,
            fileId: fileId,
            createdBy: stateObj?.userId || feedBackCreatedBy,
            moduleTypeId: 8,
            feedbackPriorityId: selectedPriority
        };
        try {
            setUseLoader(true);
            const response = await Services.postFeedback(payload);
            return response;
        } catch (err) {
            setUseLoader(false);
            return "err";
        } finally {
        }
    };
    const sendFeedBackEmail = async (blob, subtenantId, res) => {
        return new Promise(async (resolve) => {

            const file = new File([blob], "FEEDBACK.jpg", { type: "image/png" });
            let emailto = (!config?.DEMO && subtenantId == 742) ? "TechSupport@agingoptions.com" : "satyadev.sharma@agingoptions.com";
            let emailContent = `
      <p style="font-size: 16px; color: #333; background-color: #f5f5f5; padding: 10px; margin: 0; box-sizing: border-box;">
        <span style="display: block; padding-bottom: 10px;"><b>Ticket Number:</b> @@ticketno<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Name:</b> @@CLIENT_NAME<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Email:</b> @@CLIENT_EMAIL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Sender Email:</b> @@SENDER_EMAIL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Application URL:</b> @@APPLICATION_URL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Query:</b> @@FEEDBACK_QUERY<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Time:</b> @@time</span><br>
      </p>
      <p>(<b>Note:</b> Sent from @@USERTYPE)</p>
                               `;

            emailContent = emailContent
                .replace('@@CLIENT_NAME', userLoggedInDetail?.memberName || feedBackuserLoggedInDetail?.memberName)
                .replace('@@CLIENT_EMAIL', userLoggedInDetail?.primaryEmailId || feedBackuserLoggedInDetail?.primaryEmailId)
                .replace('@@SENDER_EMAIL', userLoggedInDetail?.primaryEmailId || feedBackuserLoggedInDetail?.primaryEmailId)
                .replace('@@FEEDBACK_QUERY', descriptionValue)
                .replace('@@APPLICATION_URL', window.location.href)
                .replace('@@time', currentTime)
                .replace('@@USERTYPE', 'Accounts Receivable (AR)')
                .replace('@@ticketno', res?.data?.data?.feedbackId);

            let formData = new FormData();
            formData.append('File', file);
            formData.append('EmailType', 'Client_Feedback_Details');
            formData.append('EmailTo', emailto);
            formData.append('EmailSubject', 'Feedback Details');
            formData.append('EmailContent', emailContent);
            formData.append('EmailMappingTable', 'tblMember');
            formData.append('EmailStatusId', '1');
            formData.append('EmailMappingTablePKId', stateObj?.userId || feedBackUserID);
            formData.append('CreatedBy', stateObj?.userId || feedBackCreatedBy);

            setUseLoader(true);
            await Services.sendMailFeedBack(formData).then((response) => {
                resolve(response);
            }).catch(() => {
               setUseLoader(false);
                resolve("err");
            }).finally(() => {
            });

        });
    };
    const functionForAcknowledgementMail = async (response) => {
        return new Promise(async (resolve) => {

            let emailContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Feedback Acknowledgement | New Ticket @@ticketno</title>
        </head>
        <body>
          <p>Hi @@CLIENT_NAME,</p>
          <p>We would like to acknowledge that we have received your request and a ticket @@ticketno has been created.</p>
          <p><b>Ticket Details</b></p>
          <p>Ticket No.: @@ticketno</p>
          <p>Ticket Title: @@FEEDBACK_QUERY</p>
          <p>Rest assured, our tech support team has initiated an investigation based on your feedback.</p>
          <p>Warm regards,</p>
          <p>Tech Support Team<br>Aging Options</p>
        </body>
      </html>
    `;

            emailContent = emailContent
                .replace('@@CLIENT_NAME', userLoggedInDetail?.memberName || feedBackuserLoggedInDetail?.memberName)
                .replace('@@FEEDBACK_QUERY', descriptionValue)
                .replace(/@@ticketno/g, response?.data?.data?.feedbackId);

            const jsonObj = {
                emailType: "Client_Feedback_Details",
                emailTo: userLoggedInDetail?.primaryEmailId || feedBackuserLoggedInDetail?.primaryEmailId,
                emailSubject: `Feedback Acknowledgement | New Ticket ${response?.data?.data?.feedbackId}`,
                emailContent: emailContent,
                emailStatusId: 1,
                emailMappingTable: "tblMember",
                emailMappingTablePKId: stateObj?.userId || feedBackUserID,
                createdBy: stateObj?.userId || feedBackCreatedBy,
            };

            setUseLoader(true);

            await Services.sendPostEmailCC(jsonObj).then((res) => {
                    resolve(res);
                }).catch(() => {
                    setUseLoader(false);
                    resolve("err");
                }).finally(() => {
                });

        });
    };

  return (
    <>
      {useLoader && <Loader useLoader />}
      <div className="fixed top-1/2 -translate-y-1/2 -right-6 -rotate-90 z-[9999]">
        <CustomButton label="Feedback" onClick={handleFeedbackShow} />
      </div>
      {showModal && (
        <div className="fixed inset-0 z-[999999] bg-black/60 flex items-center justify-center px-3">
          {useLoader && <Loader useLoader />}
          <div className="bg-white rounded-lg w-full max-w-3xl">
            <div className="p-4 border-b flex justify-between">
              <p className="font-medium">Feedback</p>
              <img src="/closeIcon.svg" className="w-5 cursor-pointer" onClick={handleFeedbackShow} />
            </div>

            <div className="p-4 space-y-4 overflow-y-auto max-h-[70vh]">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <p className="text-sm sm:text-base">
                  <span className="font-medium">Name:</span>{" "}
                  {userLoggedInDetail?.memberName || feedBackuserLoggedInDetail?.memberName}
                </p>

                <p className="text-sm sm:text-base">
                  <span className="font-medium">Time:</span> {currentTime}
                </p>

                <div className="flex items-center gap-2">
                  <p className="font-medium text-sm sm:text-base">Priority:</p>
                  <CustomSelect
                    id="Priority"
                    placeholder="Select priority"
                    tabIndex={100}
                    onChange={(item) =>
                      setSelectedPriority(item?.value)
                    }
                    value={selectedPriority}
                    options={feedbackPriority}
                  />
                </div>
              </div>

              <CustomTextarea
                label="Describe"
                value={descriptionValue}
                onChange={setDescriptionValue}
              />
              {imageSrc && <img src={imageSrc} className="rounded w-full" />}
            </div>

            <div className="p-4 border-t flex justify-end gap-3">
              <CustomButton label="Cancel" onClick={handleFeedbackShow} />
              <CustomButton label="Submit" onClick={handleFeedbackSubmit} />
            </div>
          </div>
        </div>
      )}

      {toast && <Toaster {...toast} onClose={() => setToast(null)} />}
    </>
  );
}

/* =========================
   SHARED COMPONENTS
========================= */

export const removeSpaceAtStart = (value) => {
  if (typeof value != "string") return value;
  return value?.replace(/^\s+/g, '');
}
export const CustomTextarea = memo(({label,value,id,onChange,placeholder,rows = 3,tabIndex,onHoverTitle,isDisable,refrencePage}) => {
    const textareaRef = useRef(null);

    const adjustHeight = () => {
      const textarea = textareaRef.current;
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    };

    const handleChange = (e) => {
      const textarea = textareaRef.current;
      const cursorPosition = textarea?.selectionStart;

      onChange(removeSpaceAtStart(e.target.value), id);

      setTimeout(() => {
        if (textarea) {
          textarea.setSelectionRange(cursorPosition, cursorPosition);
          adjustHeight();
        }
      }, 0);
    };

    useEffect(() => {
      adjustHeight();
    }, [value]);

    return (
      <div className="w-full">
        {isNotValidNullUndefile(label) && (
          <label htmlFor={id} title={onHoverTitle} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        )}

        <textarea
          ref={textareaRef}
          id={id}
          tabIndex={tabIndex}
          rows={rows}
          value={isNotValidNullUndefile(value) ? value : ""}
          placeholder={placeholder ?? ""}
          disabled={isDisable}
          onChange={handleChange}
          className={`
            w-full rounded-md border px-3 py-2 text-sm
            focus:outline-none focus:ring-2 focus:ring-blue-500
            resize-none overflow-hidden
            ${isDisable ? "bg-gray-300 opacity-50 cursor-not-allowed" : "bg-white"}
          `}
          style={{
            textTransform: "none",
            minWidth: refrencePage === "AgentGuidance" ? "100%" : undefined,
          }}
        />
      </div>
    );
  }
);
export const CustomButton = memo(({ label, onClick, tabIndex, disabled }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const debouncedOnClick = useCallback(
    debounce(async (event) => {
      if (disabled || isProcessing) return;
      setIsProcessing(true);
      await onClick(event);
      setIsProcessing(false);
    }, 300),
    [disabled, isProcessing, onClick]
  );

  const handleClick = (event) => {
    if (event.type === "keydown" && event.key === "Enter") {
      event.preventDefault();
      debouncedOnClick(event);
    }
    if (event.type === "click") {
      debouncedOnClick(event);
    }
  };

  return (
    <button
      tabIndex={tabIndex}
      disabled={disabled || isProcessing}
      onClick={handleClick}
      onKeyDown={handleClick}
      className={`
        px-4 py-2 rounded-md text-sm font-medium
        transition-all duration-200
        ${
          disabled || isProcessing
            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
            : "bg-[#720C20] text-white hover:bg-[#720C20]"
        }
      `}
    >
      {label}
    </button>
  );
});
export const CustomSelect = memo(({options = [],value,placeholder = "Select",onChange,isError,isDisable,tabIndex,id}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const dropdownRef = useRef(null);

    const selectedOption = options.find((o) => o.value === value);

    const toggleDropdown = () => {
      if (!isDisable) setIsOpen((prev) => !prev);
    };

    const handleOptionClick = (option) => {
      onChange(option);
      setIsOpen(false);
      setHighlightedIndex(-1);
    };

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
      <div ref={dropdownRef} className="relative w-full">
        {/* Select Box */}
        <div
          tabIndex={tabIndex}
          onClick={toggleDropdown}
          className={`
            flex items-center justify-between px-3 py-2 rounded-md border text-sm
            cursor-pointer
            ${isDisable ? "bg-gray-200 cursor-not-allowed" : "bg-white"}
            ${isError ? "border-red-500" : "border-gray-300"}
          `}
        >
          <span className="truncate">
            {selectedOption?.label || placeholder}
          </span>
          <img
            src="/select-icon.png"
            alt="Dropdown"
            className="ms-1 me-1"
          />
        </div>

        {/* Dropdown */}
        {isOpen && (
          <ul className="absolute z-50 mt-1 w-full bg-white border rounded-md shadow-md max-h-52 overflow-y-auto">
            {options.length ? (
              options.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`
                    px-3 py-2 text-sm cursor-pointer
                    ${
                      highlightedIndex === index
                        ? "bg-blue-100"
                        : "hover:bg-gray-100"
                    }
                  `}
                >
                  {option.label}
                </li>
              ))
            ) : (
              <li className="px-3 py-2 text-sm text-gray-500">
                Not available
              </li>
            )}
          </ul>
        )}

        {/* Error */}
        {isError && (
          <p className="text-xs text-red-500 mt-1">{isError}</p>
        )}
      </div>
    );
  }
);


